import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { LangProvider } from './i18n/LangContext'
import Layout from './components/Layout'
import HomePage from './pages/HomePage'
import CompetencyStudioPage from './pages/CompetencyStudioPage'
import TaskBuilderPage from './pages/TaskBuilderPage'
import ToolRegistryPage from './pages/ToolRegistryPage'
import RubricDesignerPage from './pages/RubricDesignerPage'
import AgentRunnerPage from './pages/AgentRunnerPage'
import TraceViewerPage from './pages/TraceViewerPage'
import ReportPage from './pages/ReportPage'
import LeaderboardPage from './pages/LeaderboardPage'
import ContributeTaskPage from './pages/ContributeTaskPage'
import ExpertDashboardPage from './pages/ExpertDashboardPage'
import DataPipelinePage from './pages/DataPipelinePage'
import DataGovernancePage from './pages/DataGovernancePage'
import SettingsPage from './pages/SettingsPage'
import BatchEvaluationPage from './pages/BatchEvaluationPage'
import ShareViewPage from './pages/ShareViewPage'

function App() {
  return (
    <LangProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/competencies" element={<CompetencyStudioPage />} />
            <Route path="/tasks" element={<TaskBuilderPage />} />
            <Route path="/tasks/new" element={<TaskBuilderPage />} />
            <Route path="/tasks/contribute" element={<ContributeTaskPage />} />
            <Route path="/expert" element={<ExpertDashboardPage />} />
            <Route path="/pipeline" element={<DataPipelinePage />} />
            <Route path="/governance" element={<DataGovernancePage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/batch" element={<BatchEvaluationPage />} />
            <Route path="/tools" element={<ToolRegistryPage />} />
            <Route path="/rubrics" element={<RubricDesignerPage />} />
            <Route path="/run" element={<AgentRunnerPage />} />
            <Route path="/traces" element={<TraceViewerPage />} />
            <Route path="/traces/:id" element={<TraceViewerPage />} />
            <Route path="/reports" element={<ReportPage />} />
            <Route path="/reports/:id" element={<ReportPage />} />
            <Route path="/leaderboard" element={<LeaderboardPage />} />
            <Route path="/share" element={<ShareViewPage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </LangProvider>
  )
}

export default App
